// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"79a56d7e","239":"b21b852a","455":"84093074"}[chunkId] + ".chunk.js";
};